// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__n9YBh","switcherWrapper":"styles_switcherWrapper__Ri8bP"};